module.exports = __webpack_public_path__ + "img/mbbr-text.1ca64ef1.svg";